<template>
  <div class="login_wrapper">
    <div class="image">
      <img v-show="baseData.logo" :src="baseData.logo" alt="" />
    </div>
    <div class="title">欢迎来到{{ baseData.systemTitle }}</div>
    <van-button
      round
      type="info"
      size="normal"
      color="#F93244"
      style="width: 91.467vw;margin-bottom: 5.333vw;"
      @click="login('pwd')"
      >密码登录</van-button
    >
    <van-button
      round
      type="primary"
      size="normal"
      plain
      style="width: 91.467vw;margin-bottom: 5.333vw;"
      color="#F93244"
      @click="login('captcha')"
      >验证码登录</van-button
    >
    <div class="register_now" @click="registerNow">
      还没有账号？立即<span class="red">注册</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data() {
    return {
      baseData: baseData
    };
  },
  methods: {
    login(type) {
      if (type == 'pwd') {
        this.$router.push({
          path: '/loginPwd',
          query: { redirect: this.$route.query.redirect }
        });
      } else {
        this.$router.push({
          path: '/loginCaptcha',
          query: { redirect: this.$route.query.redirect }
        });
      }
    },
    registerNow() {
      if (Vue.ls.get('inviterCode')) {
        this.$router.push({
          path: '/register',
          query: {
            c: Vue.ls.get('inviterCode')
          }
        });
      } else {
        this.$router.push({
          path: '/register'
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login_wrapper {
  .red {
    color: #f93244;
  }

  padding: 8.933vw 2.133vw 0 2.133vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  .image {
    width: 32vw;
    height: 32vw;
    margin-bottom: 0.533vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    font-size: 5.6vw;
    margin-bottom: 38.8vw;
    margin-top: 2.133vw;
  }

  .register_now {
    margin-top: 5.333vw;
    color: rgba(0, 0, 0, 0.25);
    font-size: 3.733vw;
  }
}
</style>
